// Angular imports
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppInfoService {
  public get title() {
    return 'CiraNet Owner / Resident Portal';
  }
}
